import { useEffect } from 'react';
import axios from 'axios';

export function useAuthRedirect(apiUrl: string, token: string | null) {
  useEffect(() => {
    const checkAuth = async () => {
      try {
        await axios.get(apiUrl, { headers: { Authorization: `Bearer ${token}` } });
      } catch (err: any) {
        if (err.response && (err.response.status === 401 || err.response.status === 403)) {
          window.location.href = '/login';
        }
      }
    };
    checkAuth();
  }, [apiUrl, token]);
}
